export const SocialMedia = {
  state: () => ({
    twitter: 'https://twitter.com/RealFluffyFucks',
    instagram: 'https://www.instagram.com/fluffy.fucks',
    discord: 'https://discord.gg/fluffyfucks'
  })
}
